import { MainService } from 'src/app/Services/service.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import * as WebFont from 'webfontloader';
@Component({
  selector: 'app-mobile-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements AfterViewInit {

  constructor(public mainService: MainService) {}

  ngAfterViewInit(): void {
    //    throw new Error("Method not implemented.");
    WebFont.load({
        google: { families: ['Material Icons', 'Material Icons Outline'], },
        fontactive: (familyName, fvd) => {
            if(familyName="Material Icons"){
                this.mainService.aplicationIsReady = true;
            }
        },
      });

}

}
